import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { IDinningApiResponse } from '../../types/api/dinningApi';
import { getDinningDataService } from '../../api/dinningApi';
import { IDinningState } from '../../types/features/dinningSlice';

export const getDinningData = createAsyncThunk<IDinningApiResponse>(
    'dinning/getDinningData',
    async () => {
        const response = await getDinningDataService();
        return response.data; // Assumes response has a 'data' property
    }
);

const dinningSlice = createSlice({
    name: 'dinning',
    initialState: {
        dinning_details: {
            name: "",
            desription: '',
            number: 0,
            timing: [],
            dress_code: [],
            image: ''
        },
        dinning_ameniti: [],
        trending_menu: [],
        trending_menu_image: "",
        dinningLoader: false,
        status: false,
        msg: ''
    } as IDinningState, // Type the initialState with AuthState
    reducers: {
    },
    extraReducers: (builder) => {
        builder
            .addCase(getDinningData.pending, (state) => {
                state.dinningLoader = true;
            })
            .addCase(getDinningData.fulfilled, (state, action: PayloadAction<IDinningApiResponse>) => {
                state.dinning_details = action.payload.data.dinning_details;
                state.dinning_ameniti = action.payload.data.dinning_ameniti;
                state.trending_menu = action.payload.data.trending_menu;
                state.trending_menu_image = action.payload.data.trending_menu_image;
                state.msg = action.payload.message;
                state.status = true;
                state.dinningLoader = false;
            })
            .addCase(getDinningData.rejected, (state, action) => {
                state.dinningLoader = false;
                state.status = false;
                state.msg = action.error.message;
            })

    }
});

export default dinningSlice.reducer;
